export default {
	IncludeDeliveryIncludePostage: 1,
	IncludeDeliveryExcludePostage: 2,
	ExcludeDeliveryExcludePostage: 3
};
